import { createFileRoute, redirect } from "@tanstack/react-router";
import { List } from "@/features/teammates";
import { AuthorizedRouteContext } from "@/routes/_authorized/route";
import { checkUserPermissions } from "@/features/auth";

const Route = createFileRoute("/_authorized/teammates/")({
  beforeLoad: async ({ context }) => {
    const { userDetails } = context as AuthorizedRouteContext;

    const isUserPermitted = checkUserPermissions(userDetails, ["TEAMMATE_LIST"]);

    if (!isUserPermitted) {
      redirect({
        to: "/consent-solutions",
        replace: true,
        throw: true,
      });
    }
  },
  component: () => <List />,
});

export { Route };
